import Axios from "axios";

const setHeaderIfEmpty = (opts, key, value) => {
    if (!opts) {
        return;
    }
    opts.headers = opts.headers ? opts.headers : {};
    if (!opts.headers[key]) {
        opts.headers[key] = value;
    }
};

/**
 * Fetch content, in the opts you can pass "useAxios" if you want to use axios instead of fetch.
 *
 * @param {String} url the url you want to call.
 * @param {Object} opts an object.
 */
const fetchWrapper = async (url, opts) => {
    opts = opts || {};

    // call Axios or fetch based on the parameters, it will try to
    // convert parameters between the two (mainly the fetch "body" parameter
    // into Axios "data" parameter).
    const callFetchApi = async function (url, opts) {
        const fetchOpt = Object.assign({}, opts);
        if (fetchOpt.useAxios) {
            delete fetchOpt.useAxios;
            if (fetchOpt.body) {
                fetchOpt.data = fetchOpt.body;
                delete fetchOpt.body;
            }
            return Axios({
                url,
                ...fetchOpt
            });
        } else {
            return fetch(url, fetchOpt);
        }
    };

    // if the response is a fetch response, await for the json
    // result and make it available as data which is also
    // compatible with Axios.
    const callResponseJson = async function (response) {
        if (response.json) {
            const json = await response.json();
            response.data = json;
            return response;
        } else {
            return response;
        }
    };
    if (!opts || opts.body || opts.method === "HEAD") {
        // In case we're simply fetching, we're sending formData or it's HEAD request
        return callFetchApi(url, opts);
    }
    const _opts = JSON.parse(JSON.stringify(opts));
    // Check POST Content-Type
    if (
        !_opts.body &&
        (_opts.method === "POST" ||
            _opts.method === "PUT" ||
            _opts.method === "SEARCH")
    ) {
        setHeaderIfEmpty(_opts, "Content-Type", "application/json");
    }
    if (_opts && _opts.data && !_opts.useAxios) {
        _opts.body = JSON.stringify(_opts.data);
        delete _opts.data;
    }
    const response = await callFetchApi(url, _opts);
    if (!response.ok) {
        let errorMsg;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const resJson = await callResponseJson(response).data;
            if (resJson) {
                errorMsg = resJson.message;
            }
        }
        if (!errorMsg) {
            errorMsg = response.statusText;
        }
        throw errorMsg;
    }
    if (response.statusText === "No Content") {
        response.data = {};
        return response;
    } else {
        return await callResponseJson(response);
    }
};

// eslint-disable-next-line import/prefer-default-export
export { fetchWrapper };
